/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import portafolio2 from "../img/portafolio2.svg";
import ecommerce from "../img/ecommerce.svg";
import marketing from "../img/marketing.svg";
import { Grid, Button } from "@material-ui/core";
import { HashLink as Link } from "react-router-hash-link";
import Fade from "react-reveal";

class Header extends Component {
  render() {
    return (
      <div className="services" id={this.props.id}>
        <Grid container direction="row" justify="center" alignItems="center">
          <div className="serviceIllus">
            <h1>
              Servicios
            </h1>
          </div>
        </Grid>
        <Grid
          container
          direction="row"
          justify="space-evenly"
          alignItems="flex-start"
          className="serviceSlider"
        >
          <Grid
            item
            container
            direction="column"
            justify="center"
            alignItems="center"
            sm={4}
            xs={12}
            className="p-5 serviceCont"
            data-aos="fade-up-right"
            data-aos-duration="900"
          >
            <Fade left>
              <img
                src={ecommerce}
                alt="ecommerce"
                className="img-fluid imgService"
                onClick={() => window.location.assign("/services/tienda")}
              />
              <h2>Tienda virtual</h2>
              <p>
                Aumenta tus ventas digitalizando tu empresa, oferta tus
                productos o servicios mediante las mejores herramientas
                tencológicas actuales.
              </p>
              </Fade>
          </Grid>
          
          <Grid
            item
            container
            direction="column"
            justify="center"
            alignItems="center"
            sm={4}
            xs={12}
            className="p-5 serviceCont"
            data-aos="fade-up-right"
            data-aos-duration="900"
          >
            <Fade left>
              <img
                src={portafolio2}
                alt="portafolio web"
                className="img-fluid  imgService"
                onClick={() => window.location.assign("/services/portafolio")}
              ></img>
              <h2>Portafolio web</h2>
              <p>
                Muestra tu trabajo o servicio al mundo digital de forma
                profesional con el objetivo de ganar clientes y contáctos
                potenciales.
              </p>
              </Fade>
          </Grid>
          <Grid
            item
            container
            direction="column"
            justify="center"
            alignItems="center"
            sm={4}
            xs={12}
            className="p-5 serviceCont"
            data-aos="fade-up-right"
            data-aos-duration="900"
          >
            <Fade left>
              <img
                src={marketing}
                alt="Marketing digital"
                className="img-fluid  imgService"
                onClick={() => window.location.assign("/services/marketing")}
              ></img>
              <h2>Marketing digital</h2>
              <p>
                Desarrolla campañas publicitarias para aumentar tus ventas y
                llegar a mucha más gente mediante el empleo efectivo de
                redes sociales.
              </p>
              </Fade>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          className="serviceButton"
        >
          <Button
            variant="contained"
            color="primary"
            disableElevation
            component={Link}
            to="/services/#"
            className="btntime"
          >
            Conoce más
          </Button>
        </Grid>
      </div>
    );
  }
}

export default Header;
